import { contextFactory } from '@frontend/design-system';
import { CompactTableData, CompactTableRowActionsProps } from '../components/compact-table/types';

export type CompactTableRowContextType = {
  tableId: string;
  id: string;
  isExpanded: boolean;
  isSelected: boolean;
  isDisabled: boolean;
  isSelectionDisabled: boolean;
  handleRowSelect: (item: any & CompactTableData, isSelected: boolean) => void;
  handleRowExpand: (item: any & CompactTableData, isExpanded: boolean) => void;
  rowActions?: CompactTableRowActionsProps<any & CompactTableData>;
  item: unknown;
  isSelectable: boolean;
};

export const [CompactTableRowContext, useCompactTableRowContext] = contextFactory<CompactTableRowContextType>(
  'useCompactTableRowContext must be used within CompactTableRowContext'
);
